import { Trans } from 'react-i18next';
import { ReactComponent as Close } from '../../assets/svg/MobileClose.svg';
import { ReactComponent as Filter } from '../../assets/svg/filter.svg';


interface MobileFilterProps {
    filterVisible: boolean,
    setFilterVisible: (value: boolean) => void,
    children?: React.ReactNode,
    onClean: () => void
}

function MobileFilter({ filterVisible, setFilterVisible, onClean, children }: MobileFilterProps) {
    return (
        <div className={'mobile-filter' + (filterVisible ? ' _show' : '')}>
            <div className="mobile-filter__header">
                <div className="mobile-filter__header-inner">
                    <div className="mobile-filter__header-heading">
                        <Filter />
                        <Trans>Filter</Trans>
                    </div>
                    <div className="mobile-filter__header-close" onClick={() => setFilterVisible(false)}>
                        <Close />
                    </div>
                </div>
            </div>

            <div className="mobile-filter__body">
                <div className="mobile-filter__body-inner">
                    {children}
                </div>
            </div>
            <div className="mobile-filter__footer">
                <div className="mobile-filter__footer-inner">
                    <span className="mobile-filter__clear" onClick={() => {
                        onClean();
                    }}>
                        <Trans>Clean</Trans>
                    </span>
                    <span className="btn mobile-filter__apply" onClick={() => {
                        setFilterVisible(false);
                    }}>
                        <Trans>Apply</Trans>
                    </span>
                </div>
            </div>
        </div>
    );
}

export default MobileFilter;
